import axios from 'axios';
import React, { Component, MouseEvent } from 'react';
import ResetPasswordModal from './containers/ResetPasswordModal/ResetPasswordModal';
import { localeStore } from 'src/mobx/localesStore';
import { userStore } from 'src/mobx/userStore';
import cookies from 'src/services/cookie';
import logger from 'src/services/logger';
import wms from 'src/services/wms';
import { takerDomainPattern } from 'src/utils/formatter';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import Input from 'src/view/components/Controls/Input/Input';
import InputApi from 'src/view/components/Controls/InputApi/InputApi';
import LanguageSwitcher from 'src/view/components/Controls/LanguageSwitcher/LanguageSwitcher';
import './style.scss';

interface IState {
  username: string;
  password: string;
  token: string;
  domain: string;
  loading: boolean;
  forgotPassModal: boolean;
  alternative: boolean;
  errors: {
    username?: boolean;
    password?: boolean;
    domain?: boolean;
    message?: string;
  };
}
export default class LoginScreen extends Component<{}, IState> {
  params: URLSearchParams = new URLSearchParams(window.location.search);
  alternative = this.params.get('alternative');
  state: IState = {
    alternative: Boolean(window.IS_MOBILE && !this.alternative),
    username: this.params.get('username') || '',
    password: this.params.get('password') || '',
    token: this.params.get('token') || '',
    domain: this.params.get('domain') || '',
    loading: false,
    forgotPassModal: false,
    errors: {
      username: false,
      password: false,
      domain: false,
    },
  };

  componentDidMount = () => {
    this.fetchToken();

    if (!window.IS_MOBILE) {
      this.clearCookies();
      // eslint-disable-next-line @typescript-eslint/unbound-method
      setTimeout(this.clearCookies, 2000);
    } else {
      cookies.setCookie('is_new_admin', '1');
    }

    if (window.IS_MOBILE) {
      cookies.setCookie('is_new_admin', '1');
      wms.setLoading(false);
    }
  };

  clearCookies() {
    cookies.deleteCookie('is_new_admin');
    cookies.deleteAllCookies();
  }

  fetchToken = async () => {
    if (window.IS_MOBILE) {
      const token = await wms.getFirebaseToken();
      if (token) {
        this.setState({ token });
      }
    }
  };

  openForgotPassModal = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    this.setState({ forgotPassModal: true });
  };

  closeForgotPassModal = () => {
    this.setState({ forgotPassModal: false });
  };

  onChangeField = (type: 'username' | 'password' | 'domain') => (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      this.setState(
        (state) => ({ ...state, [type]: event.target.value }),
        () => (this.state.errors.username || this.state.errors.password ? this.validation() : undefined)
      );
    } catch (error: any) {
      logger.error({ error, place: 'LoginScreen onChangeField' });
    }
  };
  buildDomain = (name: string) => {
    name = name.toLowerCase().trim();
    if (!/^(https?:\/\/)/.test(name)) name = `https://${name}`;
    if (!/(.my.taker.io)$/.test(name)) name = `${name}.my.taker.io`;
    return name;
  };

  checkClient = async (event?: React.FormEvent) => {
    try {
      if (event) event.preventDefault();
      this.setState(() => ({ loading: true }));
      const domain = this.buildDomain(this.state.domain);
      const isValid = takerDomainPattern.test(domain);

      if (!isValid) {
        this.setState({
          loading: false,
          errors: {
            domain: true,
          },
        });
        return;
      }
      // If we got response  it is mean that client exist
      const { data: settings } = await axios.get(`${domain}/api/v3/app/settings`);
      logger.log(settings);
      window.location.href = `${domain}/admin?alternative=true`;
      this.setState(() => ({ loading: false }));
    } catch (error: any) {
      this.setState(() => ({ loading: false }));
      logger.error({ error, place: 'LoginScreen checkClient', showModal: true });
    }
  };

  validation = (event?: React.FormEvent, submit?: boolean) => {
    if (event) event.preventDefault();
    this.setState(
      {
        errors: {
          ...this.state.errors,
          username: !Boolean(this.state.username.trim()),
          password: !Boolean(this.state.password.trim()),
          message: undefined,
        },
      },
      () => (submit ? this.submit() : undefined)
    );
  };

  submit = async () => {
    try {
      if (this.state.errors.username || this.state.errors.password) return;

      this.setState(() => ({ loading: true }));
      const data: any = {
        username: this.state.username,
        password: this.state.password,
      };
      if (window.IS_MOBILE) {
        if (!this.state.token) {
          const token = await wms.getFirebaseToken();
          if (token) {
            data.firebase_token = token;
          }
        } else {
          data.firebase_token = this.state.token;
        }
      }
      await userStore.login(data);
      this.setState(() => ({ loading: false }));
    } catch (error: any) {
      this.setState({ loading: false });
      if (error.response?.status === 401 && error.response?.data?.message) {
        this.setState({ errors: { username: true, password: true, message: error.response.data.message } });
        return;
      }
      logger.error({ error, place: 'LoginScreen submit', showModal: true });
    }
  };

  render() {
    if (this.state.alternative && !window.MOBILE_APP_VERSION) {
      // Do not touch next lines without Jaroslav!
      // Are you really risk to broke mobile app
      // Don't do this!
      return (
        <div className="login d-flex align-items-center justify-content-center flex-grow-1 full-height">
          <div className="login__language-switcher">
            <LanguageSwitcher inPicker />
          </div>

          <div className="login__content">
            <h1 className="color-mainblue text-size-36 text-center mb-10">Taker</h1>
            <form id="login" onSubmit={this.checkClient} className="d-flex flex-column">
              <div className="d-flex flex-column">
                <div className="d-flex flex-row">
                  <InputApi
                    autoFocus
                    error={this.state.errors.domain}
                    onChange={this.onChangeField('domain')}
                    disabled={this.state.loading}
                    defaultValue={this.state.domain}
                    placeholder={localeStore.t('api_url_placeholder')}
                    type="text"
                    wrapperClassName="border-gray mt-4"
                    className="input full-width text-size-18 family-medium"
                  />
                </div>
              </div>
              <Button
                type="submit"
                title={localeStore.t('txt_continue')}
                disabled={this.state.loading}
                loading={this.state.loading}
                size="large"
                stretched
                className="mt-4"
              />
            </form>
          </div>
        </div>
      );
    }
    return (
      <div className="login d-flex align-items-center justify-content-center flex-grow-1 full-height">
        <div className="login__language-switcher">
          <LanguageSwitcher inPicker />
        </div>

        <div className="login__content">
          <h1 className="color-mainblue text-size-36 text-center mb-10">Taker</h1>
          <form id="login" onSubmit={(event) => this.validation(event, true)} className="d-flex flex-column">
            <div className="d-flex flex-column">
              <div className="d-flex flex-row">
                <Input
                  onChange={this.onChangeField('username')}
                  disabled={this.state.loading}
                  defaultValue={this.state.username}
                  placeholder={localeStore.t('username_placeholder')}
                  type="text"
                  className="login__input-mini input border-gray text-size-18 family-medium"
                  error={this.state.errors.username}
                  autoFocus
                />
                <span className="pr-3"></span>
                <Input
                  onChange={this.onChangeField('password')}
                  disabled={this.state.loading}
                  defaultValue={this.state.password}
                  placeholder={localeStore.t('password_placeholder')}
                  type="password"
                  className="login__input-mini input border-gray text-size-18 family-medium"
                  error={this.state.errors.password}
                />
              </div>
              {this.state.errors.message ? <p className="family-regular text-size-14 color-red mt-2">{this.state.errors.message}</p> : null}
            </div>
            <Button
              type="submit"
              title={localeStore.t('txt_login')}
              disabled={this.state.loading}
              loading={this.state.loading}
              size="large"
              stretched
              className="mt-4"
            />
            <button onClick={this.openForgotPassModal} disabled={this.state.loading} className="login__button-pass-reset">
              {localeStore.t('txt_forget_paassword')}
            </button>
          </form>
          <ResetPasswordModal isOpen={this.state.forgotPassModal} closeForgotPassModal={this.closeForgotPassModal} />
        </div>
      </div>
    );
  }
}
